export default __webpack_public_path__ + "5d3bbcec38f9d34d9511fad7b02e8cd1.svg";